/**
 * Фильтры и страница таблицы в адресной строке.
 *
 * Без этого уход в карточку и «назад» возвращали менеджера на первую страницу
 * пустого списка: состояние жило только в стейте страницы и умирало вместе с ней.
 * Ссылку с фильтром заодно можно передать коллеге.
 */

/** Ключи, которые не являются фильтрами, но их тоже надо помнить. */
export const PAGE_KEY = 'page';
export const PAGE_SIZE_KEY = 'pageSize';

/**
 * @param searchParams URLSearchParams из useSearchParams
 * @param names имена фильтров, которые страница понимает (всё лишнее игнорируем,
 *   чтобы чужой параметр в ссылке не уехал в запрос к бэку)
 */
export const parseTableQuery = (searchParams, names) => {
  const filters = {};
  names.forEach((name) => {
    const value = searchParams.get(name);
    if (value !== null && value !== '') filters[name] = value;
  });

  const page = Number(searchParams.get(PAGE_KEY));
  const pageSize = Number(searchParams.get(PAGE_SIZE_KEY));

  return {
    filters,
    page: Number.isInteger(page) && page > 0 ? page : 1,
    pageSize: Number.isInteger(pageSize) && pageSize > 0 ? pageSize : null,
  };
};

/** Обратная операция: пустые значения в адрес не пишем, чтобы он не зарастал. */
export const buildTableQuery = (filters = {}, page = 1, pageSize = null) => {
  const query = {};

  Object.entries(filters).forEach(([name, value]) => {
    if (value === null || value === undefined || value === '') return;
    query[name] = String(value);
  });

  if (page > 1) query[PAGE_KEY] = String(page);
  if (pageSize) query[PAGE_SIZE_KEY] = String(pageSize);

  return query;
};
